const en = {
  general: {
    mv4iot: 'MV4IoT',
    userLogout: 'Logout',
  },
}

export default en
